<template>
  <div>
    <div class="mt-3">Solicitação Nº {{ idNotificacao }}</div>
    <b-row class="mt-3">
      <b-col class="col-sm-12">
        <b-button
          class="border shadow-sm mr-2"
          variant="light"
          v-b-tooltip.hover="'Voltar'"
          @click="$emit('zerarSolicitacao', 0)"
        >
          <font-awesome-icon icon="chevron-left" size="lg" fixed-width />
          <span class="align-middle">Voltar</span>
        </b-button>
      </b-col>
      <b-col class="col-sm-12 mt-3">
        <fcc-table
          striped
          hover
          :fields="fieldsGabarito"
          :items="lstGabarito"
          responsive
          :mostrarQuantidade="false"
        />
      </b-col>
    </b-row>
    <fcc-configuracao-gabarito :idNotificacao="idNotificacao" />
  </div>
</template>
<script>
import fccConfiguracaoGabarito from './fccConfiguracaoGabarito.vue'
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      lstGabarito: [],
      fieldsGabarito: [
        { key: 'respondente', label: 'Respondente', sortable: true },
        { key: 'dataresposta', label: 'Data da Resposta', sortable: true },
        { key: 'aguardando', label: 'Aguardando', sortable: true },
        { key: 'situacao', label: 'Status', sortable: true }
      ]
    }
  },
  components: {
    fccConfiguracaoGabarito
  },
  props: {
    idNotificacao: String,
    controlePage: Object
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarGabarito()
  },
  methods: {
    listarGabarito() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/Listar/${this.controlePage.spi}/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstGabarito = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>